import type { InputState } from '../../core/input/actions';
import { el } from '../components/el';

/** On-screen gas, brake, horn and pause for phones. Hidden on devices without touch. */
export function createTouchPedals(parent: HTMLElement, input: InputState): HTMLElement {
  const root = el('div', 'pedals');
  const brake = el('button', 'pedal brake', 'BRAKE');
  const gas = el('button', 'pedal gas', 'GAS');
  const bind = (button: HTMLButtonElement, action: 'gas' | 'brake'): void => {
    const source = `pedal:${action}`;
    button.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      e.stopPropagation();
      // Keep the pedal pressed even if the thumb slides a little off the button.
      button.setPointerCapture(e.pointerId);
      input.hold(action, source, true);
    });
    const release = (): void => input.hold(action, source, false);
    button.addEventListener('pointerup', release);
    button.addEventListener('pointercancel', release);
    button.addEventListener('lostpointercapture', release);
  };
  bind(brake, 'brake');
  bind(gas, 'gas');
  const horn = el('button', 'pedal horn', '📯');
  horn.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    e.stopPropagation();
    input.press('horn');
  });
  root.append(brake, horn, gas);
  const pause = el('button', 'pause-btn');
  pause.append(el('i'), el('i'));
  pause.setAttribute('aria-label', 'Pause');
  pause.addEventListener('pointerdown', (e) => {
    e.preventDefault();
    e.stopPropagation();
    input.press('pause');
  });
  parent.append(root, pause);
  return root;
}
